export function findDeviceInfo() {
    try {
        if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
            return 'ios';
        }
        if (navigator.userAgent.match(/Android/i)) {
            return 'android';
        }
    } catch (e) {
        console.error('Error analyzing device', e);
    }
    return 'unknown';
}
